module.exports = __webpack_public_path__ + "static/media/53.41e02b02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/53.svg
// module id = 174
// module chunks = 0